import { setUserProfilePicture } from "reducers/UserProfile";
import { setUserRole } from "reducers/UserPermission";
import avatar1 from "../assets/utils/images/avatars/1.jpg";
import AuthService from "Api/Auth";

const InitUserState = (configureStore) => {   
    let userData = localStorage.getItem('user');
    userData = userData ? JSON.parse(userData) : null;  
    configureStore.dispatch(setUserProfilePicture(userData == null || userData.profileImage === '' ? avatar1 : userData.profileImage));
    let userRole = localStorage.getItem('USER_ROLES');
    if (userRole) {
        try {
            userRole = JSON.parse(userRole);
        } catch (e) {
            console.error('Error parsing USER_ROLES:', e);
            userRole = []; 
        }
    } else {
        userRole = [];  
    }

    // Migrate legacy CAN_ACCESS_AFAS flag into the soft "afas" role once.
    const legacyAfas = localStorage.getItem('CAN_ACCESS_AFAS');
    if (
        Array.isArray(userRole) &&
        userRole.length > 0 &&
        !userRole.includes(AuthService.AFAS_ROLE) &&
        legacyAfas === '1'
    ) {
        userRole = AuthService.rolesWithAfasAccess(userRole, true);
        AuthService.setUserRoles(userRole);
    }

    // Dispatch user role
    configureStore.dispatch(setUserRole(userRole));
};

const InitReduxState = {
    InitUserState
};

export default InitReduxState;
